import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import AbilitiesService from 'donor-elf-web/services/abilities';

export default class DeleteContactRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare store: Store;

  beforeModel(transition: any) {
    if (this.abilities.noAbility('edit_contact')) {
      transition.abort();
    }
  }

  async model() {
    let contact = this.modelFor('funds.fund.contacts.contact')?.contact;
    let lines = (
      await this.store.query('line-item', {
        filter: { contact_id: contact.id, limit: 1 },
      })
    ).slice();
    return {
      contact,
      hasGifts: lines.length > 0,
    };
  }
}
